/**
 * @generated SignedSource<<815c680cbb344d569ad957aafbf4d1cb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_softwareCodePage_Repositories$data = {
  readonly devOps: {
    readonly providers: {
      readonly " $fragmentSpreads": FragmentRefs<"main_softwareCodePage_MoreMenu">;
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"main_softwareCodePage_RepositoriesList">;
  readonly " $fragmentType": "main_softwareCodePage_Repositories";
};
export type main_softwareCodePage_Repositories$key = {
  readonly " $data"?: main_softwareCodePage_Repositories$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_softwareCodePage_Repositories">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "siteAri"
    }
  ],
  "kind": "Fragment",
  "name": "main_softwareCodePage_Repositories",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "main_softwareCodePage_RepositoriesList"
    },
    {
      "kind": "RequiredField",
      "field": {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
          {
            "kind": "RequiredField",
            "field": {
              "args": [
                {
                  "kind": "Variable",
                  "name": "id",
                  "variableName": "siteAri"
                },
                {
                  "kind": "Literal",
                  "name": "providerTypes",
                  "value": [
                    "DEV_INFO"
                  ]
                }
              ],
              "concreteType": "DevOpsProviders",
              "kind": "LinkedField",
              "name": "providers",
              "plural": false,
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "main_softwareCodePage_MoreMenu"
                }
              ]
            },
            "action": "THROW",
            "path": "devOps.providers"
          }
        ]
      },
      "action": "THROW",
      "path": "devOps"
    }
  ],
  "type": "Query"
};

(node as any).hash = "08244d476d4a93234c5096c5b918ae21";

export default node;
